import { render, staticRenderFns } from "./TireWinter.vue?vue&type=template&id=b1b66c48&scoped=true&"
var script = {}
import style0 from "./TireWinter.vue?vue&type=style&index=0&id=b1b66c48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b66c48",
  null
  
)

export default component.exports